var se = Object.defineProperty;
var re = (t, e, n) => e in t ? se(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var I = (t, e, n) => re(t, typeof e != "symbol" ? e + "" : e, n);
import { reactive as K, computed as E, ref as oe, onMounted as $, onUnmounted as ce, defineComponent as V, createElementBlock as T, createCommentVNode as ie, openBlock as b, Fragment as N, renderList as Q, withModifiers as ae, normalizeClass as G, unref as L, toDisplayString as j, createTextVNode as ue, createBlock as J, watch as le, withDirectives as de, vShow as ge, createApp as he } from "vue";
import pe from "@constructor-io/constructorio-client-javascript";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
const me = (t, e = 300, n = 1e3) => {
  let s, r, o, c, i = 0;
  const u = () => {
    s && clearTimeout(s), r && clearTimeout(r), s = void 0, r = void 0;
  }, h = (p, l) => {
    u(), i = Date.now(), Promise.resolve(t.apply(c, o)).then(p).catch(l);
  };
  return function(...l) {
    o = l, c = this;
    const m = Date.now();
    i === 0 && (i = m);
    const x = m - i;
    return new Promise((S, v) => {
      if (x >= n) {
        h(S, v);
        return;
      }
      s && clearTimeout(s), s = setTimeout(() => h(S, v), e), r || (r = setTimeout(() => h(S, v), n - x));
    });
  };
}, fe = (t = document) => t.readyState === "loading", P = /* @__PURE__ */ new Map(), ve = (t) => {
  var s;
  if (!t) return {};
  let e;
  try {
    e = document.querySelector(t);
  } catch {
    return {};
  }
  if (!e || !(e instanceof HTMLScriptElement)) return {};
  if (e.getAttribute("type") !== "application/json") return {};
  const n = {
    source: "domElems.getApplicationJsonData",
    jsonTextContent: e.textContent,
    selector: t
  };
  try {
    const r = JSON.parse((s = e.textContent) == null ? void 0 : s.trim());
    if (typeof r != "object" || r === null || Array.isArray(r)) {
      const o = new Error(`Invalid JSON structure in script tag with selector: ${t}`);
      return F(o, n), {};
    }
    return r;
  } catch (r) {
    const o = new Error(`Failed to parse JSON from script tag with selector: ${t}. Original error: ${r == null ? void 0 : r.message}`);
    return F(o, n), {};
  }
}, D = (t) => {
  if (P.has(t))
    return P.get(t);
  try {
    const e = document.querySelector(t);
    if (e instanceof HTMLElement)
      return P.set(t, e), e;
  } catch (e) {
    F(e, {
      source: "domElems.getDOMElem",
      selector: t
    });
  }
  return P.set(t, null), null;
}, ye = (t) => {
  let e;
  try {
    e = document.querySelector(t);
  } catch {
  }
  return e instanceof HTMLElement;
}, Ae = (t) => {
  const e = {};
  Object.entries(t).forEach(([s, r]) => {
    e[s] = D(r);
  });
  const n = Object.entries(e).filter(([, s]) => s === null).map(([s]) => t[s]);
  if ((n == null ? void 0 : n.length) > 0) {
    const s = new Error("Autosuggest missing required DOM elements");
    return F(s, {
      source: "domElems.validateAndCacheDomElems",
      missingSelectors: n
    }), !1;
  }
  return !0;
}, M = {
  SEARCH_INPUT: "input[data-js=search-field]",
  SEARCH_FORM: "form[data-js=search-form]",
  AUTOSUGGEST_WRAPPER: "div[data-js=suggestion-box]",
  RECENT_SEARCH_BOX_WRAPPER: "div[data-js=recent-search-box]"
}, B = "#gnav-data", Ee = {
  ENTER: "Enter",
  ESC: "Escape",
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  HOME: "Home",
  END: "End"
}, Se = "Search Suggestions", z = (t = B) => {
  const {
    enableAutosuggest: e = !1,
    searchAction: n = "",
    useConstructorAutosuggest: s = !1
  } = ve(t);
  return !!e && n === "/search" && !!s;
}, Ie = (t = {}) => {
  const {
    gnavDataJsonSelector: e
  } = t;
  return z(e) && Ae(M);
}, we = (t, e) => {
  var r, o;
  const n = (o = (r = window == null ? void 0 : window.document) == null ? void 0 : r.location) == null ? void 0 : o.hostname;
  if (!(n == null ? void 0 : n.includes("www.rei.com"))) {
    const c = {
      component: "SearchInputSuggestions",
      vendor: "C9r",
      ...e
    }, i = "color: red;";
    console.group("%cError in Search Input Suggestions", i), console.log(`%cMessage: ${t.message}`, i), console.log("%cContext:", i), console.dir(c), console.groupEnd();
  }
}, xe = (t = 5e3, e = 500) => new Promise((n, s) => {
  let r = 0;
  const o = Math.ceil(t / e), c = () => {
    var i;
    typeof ((i = window == null ? void 0 : window.DD_RUM) == null ? void 0 : i.addError) == "function" ? n(window.DD_RUM) : (r += 1, r >= o ? s(new Error(`DD_RUM not available after ${o} attempts`)) : setTimeout(c, e));
  };
  c();
}), Re = (t, e) => (n, s) => {
  const r = {
    component: "SearchInputSuggestions",
    vendor: "C9r",
    ...s
  };
  return e().then((o) => {
    try {
      o == null || o.addError(n, r);
    } catch (c) {
      const i = {
        ...r,
        ddRumFailure: !0,
        ddRumErrMsg: (c == null ? void 0 : c.message) ?? "Unknown DD_RUM runtime error"
      };
      t(n, i);
    }
  }).catch((o) => {
    const c = {
      ...r,
      ddRumFailure: !0,
      ddRumErrMsg: (o == null ? void 0 : o.message) ?? "Unknown DD_RUM init error"
    };
    t(n, c);
  });
}, F = Re(we, xe), be = (t, e = {}) => ({
  handler: typeof e[t.key] == "function" ? e[t.key] : () => {
  }
}), C = class C {
  /**
   * Get the singleton instance of UserService
   */
  static getInstance() {
    return C.instance || (C.instance = new C()), C.instance;
  }
  /**
   * Gets the online account number from utag_data or by API call
   * @returns A promise that resolves to the online account number or null
   */
  static async getOnlineAccountNumber() {
    const e = window == null ? void 0 : window.utag_data, { isLoggedIn: n, onlineAccountNumber: s } = e || {};
    if (n === "logged in" && s)
      return s;
    if (!e) {
      const r = await C.fetchUser();
      return typeof (r == null ? void 0 : r.accountId) == "string" ? r.accountId : null;
    }
    return null;
  }
  /**
   * Fetches user data from the API
   * @returns A promise that resolves to user data or null
   */
  static async fetchUser() {
    try {
      const e = await fetch("/rest/user/account");
      return e.ok ? await e.json() : null;
    } catch {
      return null;
    }
  }
};
I(C, "instance");
let U = C;
const Ce = (t) => [
  // ...fetchFailMsgList,
  // https://constructor-io.github.io/constructorio-client-javascript/modules_autocomplete.js.html#line210
  "getAutocompleteResults response data is malformed"
].includes(t == null ? void 0 : t.message), w = class w {
  constructor(e, n) {
    /**
     * A Constructor apiKey is a workspace index key
     * that maps to a particular environment or context. (not considered secret)
     * https://app.constructor.io/dashboard/indexes
     * @private
     */
    I(this, "apiKey");
    /**
     * Remote Constructor API service endpoint
     * https://constructor-io.github.io/constructorio-client-javascript/ConstructorIO.html
     * @private
     */
    I(this, "serviceUrl");
    /** See type interface for info */
    I(this, "c9rConfig");
    /**
     * Constructor.io JavaScript client (external/third-party)
     * https://constructor-io.github.io/constructorio-client-javascript/index.html
     * @private
     */
    I(this, "constructorIO");
    /**
     * Tracks number of errors logged and is used as a check against spamming Datadog
     * if a repetitive error condition is reached with some allowance for optional retry
     * but largely due to the high frequency nature of autosuggest UI keyboard input behavior.
     * @private
     */
    I(this, "loggedErrorCount");
    /**
     * REI CIAM user id, if available due to user being logged in.
     * https://rei-coop.atlassian.net/wiki/spaces/OC/pages/4786229/Customer+Identity+and+Access+Management+CIAM+Overview
     * @private
     */
    I(this, "userId");
    if (w.instance)
      throw new Error("Use AutoSuggestClient.getInstance() to access the singleton instance.");
    this.initProperties(e, n);
  }
  /**
   * Initializes instance properties during class construction
   * @param {string} apiKey Constructor API index reference
   * @param {string} serviceUrl Remote Constructor API service endpoint
   * @private
   * @return {void}
   */
  initProperties(e, n) {
    this.apiKey = e, this.serviceUrl = n, this.c9rConfig = {
      resultsPerSection: {
        "Search Suggestions": 10
      }
    }, this.constructorIO = null, this.loggedErrorCount = 0, this.userId = null, w.instance = this;
  }
  /**
   * Getter and factory method for Constructor third-party API client that holds autocomplete module
   * @private
   * @return Promise<ConstructorIO>
   */
  async getC9rClientInstance() {
    if (!this.constructorIO) {
      const e = await U.getOnlineAccountNumber();
      this.userId = e || null, this.constructorIO = new pe({
        apiKey: this.apiKey,
        serviceUrl: this.serviceUrl,
        userId: this.userId
      });
    }
    return this.constructorIO;
  }
  /**
   * Getter and singleton factory method for this class
   * @param {string} apiKey Constructor API index reference
   * @param {string} serviceUrl Remote Constructor API service endpoint
   */
  static getInstance(e, n) {
    return w.instance || (w.instance = new w(
      e,
      n
    )), w.instance;
  }
  /**
   * Main autocomplete/autosuggest results getter with no error logging.
   * that initializes external ConstructorIO client on first attempt.
   * Public access deprecated in favor of `getAutosuggestResultsWithErrLogAndRetry`.
   * @param {string} searchTerm
   * @param {C9rResultsConfig} resultsConfig
   */
  async getAutosuggestResults(e, n = this.c9rConfig) {
    return (await this.getC9rClientInstance()).autocomplete.getAutocompleteResults(e, n);
  }
  /**
   * Preferred main autocomplete/autosuggest results getter that wraps getAutosuggestResults
   * and offers limited logging and an optional retry for certain error patterns.
   * @param {string} searchTerm
   * @param {C9rResultsConfig} resultsConfig
   * @param {{ count: number, limit: number }} retryConfig
   * @return {unknown}
   */
  async getAutosuggestResultsWithErrLogAndRetry(e, n, s = { count: 0, limit: 0 }) {
    let r;
    try {
      r = await this.getAutosuggestResults(e, n);
    } catch (o) {
      const { count: c, limit: i } = s, u = {
        source: "getAutosuggestResultsWithErrLogAndRetry",
        isErrorRetryable: Ce(o),
        resultsConfig: n,
        retryConfig: s,
        searchTerm: e
      };
      if (this.resolveError(o, u), u.isErrorRetryable && i && c < i) {
        const h = { ...s };
        h.count += 1, r = await this.getAutosuggestResultsWithErrLogAndRetry(e, n, h);
      }
    }
    return r;
  }
  /**
   * Provides wrapper for logging errors using logger util and provides:
   * - A limit guard for logging to allow a single log per session/instance
   *   that is padded for any retry limit for the first error
   * - Common context data that is shared by any error in this class
   * @param {Error | unknown} error
   * @param {object} context
   * @private
   * @return {void}
   */
  resolveError(e, n) {
    const { retryConfig: { limit: s = 0 } } = n || {};
    if (this.loggedErrorCount < s + 1) {
      const { apiKey: r, serviceUrl: o, userId: c } = this;
      F(e, {
        ...n,
        source: `AutosuggestClient.${n.source}`,
        apiKey: r,
        serviceUrl: o,
        userId: c,
        vendor: "C9r"
      }), this.loggedErrorCount += 1;
    }
  }
};
I(w, "instance");
let W = w;
const _e = async (t, e) => W.getInstance(
  // apiKey is index key, not considered secret
  // https://app.constructor.io/dashboard/indexes
  "key_9Mi6wJ14xYHiFlPx",
  "https://ezeubuswo-zone.cnstrc.com/"
).getAutosuggestResultsWithErrLogAndRetry(
  t,
  e
), { SEARCH_INPUT: Oe, RECENT_SEARCH_BOX_WRAPPER: Te } = M, De = me(_e, 70, 700), g = K({
  query: "",
  searchFieldIsFocused: !1,
  cleanQuery: E(() => g.query.trim()),
  isValidQuery: E(() => !!g.cleanQuery),
  suggestions: [],
  // TODO why not just computed?
  suggestionsLength: 0
});
function k(t = Oe) {
  let e, n = !1;
  function s(a) {
    e.setAttribute("aria-expanded", String(a));
  }
  function r(a) {
    e.value = a, g.query = a;
  }
  function o() {
    e.focus();
  }
  function c() {
    e.blur();
  }
  function i(a) {
    e.setAttribute("aria-activedescendant", a >= 0 ? `autosuggest-result-${a}` : "");
  }
  const u = D(Te), h = oe([]), p = E(
    () => h.value.map(
      (a) => {
        var d;
        return {
          key: (d = a.data.id) == null ? void 0 : d.trim().toLowerCase().replace(/\s+/g, "-"),
          term: a.value
        };
      }
    )
  );
  async function l() {
    var y;
    if (!g.isValidQuery) return;
    const d = await De(g.query);
    h.value = ((y = d == null ? void 0 : d.sections) == null ? void 0 : y["Search Suggestions"]) || [], g.suggestionsLength = p.value.length, g.suggestions = p.value;
  }
  function m() {
    g.query = e.value, g.searchFieldIsFocused = !0, setTimeout(() => {
      var d;
      const a = ((d = u == null ? void 0 : u.dataset) == null ? void 0 : d.visible) === "visible";
      (g.isValidQuery && g.searchFieldIsFocused && g.suggestionsLength > 0 || a) && s(!0);
    }, 0);
  }
  function x() {
    g.searchFieldIsFocused = !1, s(!1);
  }
  function S() {
    g.query = e.value;
  }
  const v = {
    focus: {},
    blur: {},
    input: {},
    keydown: {}
  }, _ = [];
  function A(a, d, y, O = !1) {
    if (!v[a][d]) {
      if (O && (v[a][d] = y, e.addEventListener(a, y)), !n) {
        _.push({ type: a, name: d, handler: y });
        return;
      }
      v[a][d] = y, e.addEventListener(a, y);
    }
  }
  function q() {
    Object.keys(v).forEach((a) => {
      const d = v[a];
      Object.entries(d).forEach(([y, O]) => {
        e.removeEventListener(a, O), delete d[y];
      });
    });
  }
  return $(() => {
    e = D(t), A("focus", "setSearchInputState", m, !0), A("blur", "setSearchInputState", x, !0), A("input", "setQueryState", S, !0), n = !0, A("focus", "autosuggestResultsWatcher", l), _.forEach(({ type: a, name: d, handler: y }) => {
      A(a, d, y);
    }), _.length = 0;
  }), ce(() => {
    q(), _.length = 0, g.query = "", g.searchFieldIsFocused = !1, g.suggestions = [], g.suggestionsLength = 0;
  }), {
    searchInputState: g,
    getAutosuggestResultsAndSetSearchInputState: l,
    setAriaExpanded: s,
    updateInputFieldValue: r,
    focusOnInputField: o,
    blurOnInputField: c,
    setAriaActiveDescendant: i,
    watchInputFieldEvent: A
  };
}
const { SEARCH_FORM: Fe } = M;
function X(t = Fe) {
  let e;
  const {
    updateInputFieldValue: n,
    setAriaActiveDescendant: s
  } = k();
  function r(o, c) {
    if (o < 0 || !c) return;
    n(c), s(o);
    const i = new CustomEvent(
      "termSelected",
      {
        bubbles: !0,
        cancelable: !0
      }
    );
    e.dispatchEvent(i);
  }
  return $(() => {
    e = D(t);
  }), {
    updateAndSubmitSearchForm: r
  };
}
const f = K({
  activeIndex: -1
});
function Y() {
  const {
    searchInputState: t,
    updateInputFieldValue: e,
    focusOnInputField: n,
    blurOnInputField: s,
    setAriaActiveDescendant: r
  } = k(), {
    updateAndSubmitSearchForm: o
  } = X(), {
    ENTER: c,
    ESC: i,
    ARROW_UP: u,
    ARROW_DOWN: h,
    ARROW_LEFT: p,
    ARROW_RIGHT: l,
    HOME: m,
    END: x
  } = Ee, S = () => {
    var H;
    const R = (H = t.suggestions[f.activeIndex]) == null ? void 0 : H.term;
    o(f.activeIndex, R);
  }, v = () => {
    f.activeIndex = -1, e(""), s(), n();
  }, _ = (R) => {
    R.preventDefault(), f.activeIndex <= 0 ? f.activeIndex = t.suggestionsLength - 1 : f.activeIndex -= 1;
  }, A = (R) => {
    R.preventDefault(), f.activeIndex < 0 && (f.activeIndex = -1), f.activeIndex >= t.suggestionsLength - 1 && (f.activeIndex = -1), f.activeIndex += 1;
  }, q = () => {
    f.activeIndex = -1;
  }, a = () => {
    f.activeIndex = -1;
  }, d = () => {
    f.activeIndex = -1;
  }, y = () => {
    f.activeIndex = -1;
  }, O = {
    [c]: S,
    [i]: v,
    [u]: _,
    [h]: A,
    [p]: q,
    [l]: a,
    [m]: d,
    [x]: y
  };
  return {
    listboxState: f,
    handleKeydown: (R, H = O) => {
      const { isValidQuery: te, searchFieldIsFocused: ne } = t;
      te && ne && (be(R, H).handler(R), r(f.activeIndex));
    },
    keydownHandlers: O
  };
}
const Le = ["id", "data-cnstrc-item-section", "data-cnstrc-item-name", "aria-selected", "onMouseover", "onMousedown"], Me = /* @__PURE__ */ V({
  __name: "SearchListbox",
  props: {
    suggestions: {
      type: Array,
      required: !0
    },
    query: {
      type: String,
      default: ""
    },
    c9rSection: {
      type: String,
      required: !0
    },
    activeIndex: {
      type: Number,
      default: -1
    }
  },
  setup(t) {
    const e = t, {
      listboxState: n
    } = Y(), {
      setAriaActiveDescendant: s
    } = k(), {
      updateAndSubmitSearchForm: r
    } = X(), o = E(() => {
      const {
        termParts: u
      } = e.suggestions[0];
      return Array.isArray(u) && u.length > 0;
    }), c = E(() => {
      const {
        activeIndex: u
      } = n;
      return u >= 0 ? u : e.activeIndex;
    }), i = (u) => {
      n.activeIndex = u, s(u);
    };
    return (u, h) => t.suggestions.length > 0 ? (b(), T("ul", {
      key: 0,
      id: "gnav-suggestion-list",
      "aria-label": "Search Suggestions",
      role: "listbox",
      class: "search-listbox",
      onMouseleave: h[0] || (h[0] = (p) => i(-1))
    }, [(b(!0), T(N, null, Q(t.suggestions, (p, l) => (b(), T("li", {
      id: `autosuggest-result-${l}`,
      key: p.key,
      "data-cnstrc-item-section": e.c9rSection,
      "data-cnstrc-item-name": p.term,
      role: "option",
      class: G(["search-listbox__list-item", {
        "search-listbox__list-item--active search-term": l === c.value
      }]),
      "aria-selected": l === c.value,
      onMouseover: (m) => i(l),
      onMousedown: ae((m) => L(r)(l, p.term), ["left"])
    }, [o.value ? (b(!0), T(N, {
      key: 0
    }, Q(p.termParts, (m) => (b(), T("span", {
      key: m.key,
      class: G({
        "search-listbox__list-item--query-text": m.queryText
      })
    }, j(m.text), 3))), 128)) : (b(), T(N, {
      key: 1
    }, [ue(j(p.term), 1)], 64))], 42, Le))), 128))], 32)) : ie("", !0);
  }
}), He = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [s, r] of e)
    n[s] = r;
  return n;
}, Pe = /* @__PURE__ */ He(Me, [["__scopeId", "data-v-cbdf8c00"]]), ke = /* @__PURE__ */ V({
  __name: "SearchAutosuggest",
  props: {
    suggestions: {
      type: Array,
      required: !0,
      validator(t) {
        return Array.isArray(t) && t.length <= 10;
      }
    },
    query: {
      type: String,
      required: !0
    },
    c9rSection: {
      type: String,
      required: !0
    },
    activeIndex: {
      type: Number,
      default: -1
    }
  },
  setup(t) {
    const e = t, n = E(() => e.suggestions.slice(0, 10)), s = E(() => e.query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")), r = E(() => new RegExp(`(\\b${s.value}\\b|${s.value})`, "gi")), o = E(() => n.value.map((c) => {
      const {
        term: i,
        key: u
      } = c;
      return {
        termParts: i.split(r.value).filter((l) => l !== "").map((l, m) => ({
          text: l.replace(/ /g, " "),
          queryText: l.toLowerCase() === s.value.toLowerCase(),
          key: `${u}-part-${m}`
        })),
        ...c
      };
    }));
    return (c, i) => (b(), J(Pe, {
      suggestions: o.value,
      query: e.query,
      "c9r-section": e.c9rSection,
      "active-index": e.activeIndex
    }, null, 8, ["suggestions", "query", "c9r-section", "active-index"]));
  }
}), qe = /* @__PURE__ */ V({
  __name: "SearchInputSuggestions",
  setup(t) {
    const {
      AUTOSUGGEST_WRAPPER: e
    } = M, {
      searchInputState: n,
      getAutosuggestResultsAndSetSearchInputState: s,
      focusOnInputField: r,
      blurOnInputField: o,
      watchInputFieldEvent: c,
      setAriaExpanded: i
    } = k(), {
      handleKeydown: u,
      keydownHandlers: h,
      listboxState: p
    } = Y();
    let l;
    const m = E(() => n.isValidQuery && n.suggestionsLength > 0 && n.searchFieldIsFocused), x = E(() => m.value ? "autosuggest" : "none");
    async function S() {
      n.cleanQuery ? (p.activeIndex = -1, await s(), n.suggestionsLength ? i(!0) : i(!1)) : (o(), r());
    }
    return $(() => {
      l = D(e), le(m, () => {
        l.dataset.visible = m.value ? "visible" : "hidden";
      }), c("input", "sisTracked", S), c("keydown", "listboxNavigation", (v) => u(v, h));
    }), (v, _) => {
      var A;
      return de((b(), J(ke, {
        "c9r-section": L(Se),
        suggestions: L(n).suggestions,
        query: L(n).cleanQuery,
        "active-index": (A = L(p)) == null ? void 0 : A.activeIndex,
        class: "search-input-suggestions"
      }, null, 8, ["c9r-section", "suggestions", "query", "active-index"])), [[ge, x.value === "autosuggest"]]);
    };
  }
}), { AUTOSUGGEST_WRAPPER: Z } = M, ee = (t, e) => {
  const n = new Error(t);
  F(n, e);
};
var Ne = /* @__PURE__ */ ((t) => (t.mount = "Failed Vue createApp and mount", t.mountDomTarget = "Missing Vue app mount rootContainer DOM target", t))(Ne || {});
const Ue = (t) => {
  if (Ie(t)) {
    const e = D(Z);
    try {
      he(qe).mount(e);
    } catch (n) {
      ee("Failed Vue createApp and mount", { cause: n.message, source: "initSearch" });
    }
  }
}, We = (t, e = !1) => {
  const { gnavDataJsonSelector: n = B } = t || {}, s = "DOMContentLoaded";
  if (ye(Z))
    Ue(t);
  else if (fe() && !e)
    document.addEventListener(
      s,
      () => We(t, !0),
      { once: !0 }
    );
  else if (z(n)) {
    const o = `initSearchWithDomLoadGuard${e ? ` from ${s}` : ""}`;
    ee("Missing Vue app mount rootContainer DOM target", { source: o });
  }
};
export {
  Ne as MainError,
  We as default
};
